import { PropsWithChildren } from 'react';
import { Box } from '@customink/pigment-react';

export function Centered({ children }: PropsWithChildren<unknown>) {
    return <Box sx={{ textAlign: 'center' }}>{children}</Box>;
}
